import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import BaseLayout from 'pricing-pages-ui-components/layouts/BaseLayout';
import { BodyBackgroundStyles } from 'pricing-pages-ui-components/stylesheets/BodyBackground.styles';
import { GlobalWebBrandingStyles } from 'pricing-pages-ui-components/stylesheets/GlobalWebBranding.styles';
import { SideNavOverrideStyles } from 'pricing-pages-ui-components/stylesheets/SideNavOverride.styles';
import { useEffect, useRef } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Owns the public app chrome (HSGlobalNav header/footer, global
 * stylesheets, and scroll-to-top on navigation). Mounted above Routes
 * so it stays alive across navigation — otherwise the gate decision
 * in Routes would tear down the nav on every transition.
 */
const PublicRootLayout = ({
  children
}) => {
  const {
    pathname
  } = useLocation();
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const scrollRef = useRef(null);
  useEffect(() => {
    if (!window.location.hash) {
      var _scrollRef$current;
      (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.scrollIntoView();
    }
  }, [pathname]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BodyBackgroundStyles, {}), isTrellis && /*#__PURE__*/_jsx(GlobalWebBrandingStyles, {}), isTrellis && /*#__PURE__*/_jsx(SideNavOverrideStyles, {}), /*#__PURE__*/_jsx("div", {
      ref: scrollRef,
      "aria-hidden": true
    }), /*#__PURE__*/_jsx(BaseLayout, {
      isLoggedIn: false,
      pathname: pathname,
      children: children
    })]
  });
};
export default PublicRootLayout;